<template>
  <div>
    <validation-provider
      :name="question.label"
      v-if="hasAnswer(answer) && isTextType(question) && isRequired(question)"
      rules="required"
      mode="lazy"
      v-slot="{ errors }"
    >
      <h4 class="question_text__title required">{{ question.question }} *</h4>
      <p class="question_text__description">{{ question.attributes.description }}</p>
      <vs-input
        class="question_text__input no-icon-border"
        type="text"
        v-model="answer.value"
        :danger="errors.length > 0"
        :danger-text="`Campo de resposta obrigatória` || ''"
        @change="$emit('input', event.target.value)"
      />
    </validation-provider>
    <validation-provider
      :name="question.label"
      v-if="hasAnswer(answer) && isTextType(question) && !isRequired(question)"
      v-slot="{ errors }"
      mode="lazy"
    >
      <h4 class="question_text__title">{{ question.question }}</h4>
      <p class="question_text__description">{{ question.attributes.description }}</p>
      <vs-input
        class="question_text__input no-icon-border"
        type="text"
        v-model="answer.value"
        :danger="errors.length > 0"
        :danger-text="errors[0] || ''"
        @change="$emit('change', $event.target.value)"
      />
    </validation-provider>
  </div>
</template>

<style lang="scss" scoped>
.question_text__title {
  font-size: 16px;
  font-weight: 400;
  line-height: 18.75px;
  color: #4F4F4F;
  margin: 10px 0;
}

.question_text__description {
  font-size: 14px;
  font-weight: 400;
  line-height: 16.41px;
  color: #4F4F4F;
  margin-bottom: 10px;
}

.question_text__input {
  width: 100%;
  margin-bottom: 5px;
  color: #000;
}

.required {
  color: #333333;
}
</style>

<script>
import { ValidationProvider } from "vee-validate";

export default {
  components: { ValidationProvider },
  name: "question-text",
  props: {
    answer: {
      type: Object,
      required: true
    },
    question: {
      type: Object,
      required: true
    }
  },
  methods: {
    hasAnswer: answer => Object.keys(answer).length > 0,
    isTextType: question => question.type === "text",
    isRequired: question => question.required
  }
};
</script>
